import React from 'react'

import { Grid, Input, SimpleCollapse } from 'components'
import { SPACING } from 'utils'

export interface IDenunciaAlertaCollapse {
  control: any
  errors: any
}
const DenunciaAlertaCollapse: React.FC<IDenunciaAlertaCollapse> = ({
  control,
  errors
}) => {
  return (
    <SimpleCollapse title="DENUCIAS E ALERTAS DO CONTRATO">
      <Grid
        gridCols="1fr 1fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing5} 0`}
      >

        <Input
          control={control}
          errors={errors}
          label="Denúncia"
          placeholder=""
          formValue="txDenuncia"
          disabled
        />

        <Input
          control={control}
          errors={errors}
          label="Alerta"
          placeholder=""
          formValue="txAlerta"
          disabled
        />
      </Grid>
    </SimpleCollapse>
  )
}

export default DenunciaAlertaCollapse
